// This is being used for the hours/days toggle in the data overview leave page
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hours-days-toggle"
export default class extends Controller {
  static targets = ["value", "unit", "hoursLabel", "daysLabel"]

  connect() {
    console.log("Hours/Days toggle controller connected")
    this.originalValues = new Map()
    this.isHours = true
    
    // Store original hour values
    this.valueTargets.forEach((target, index) => {
      const text = target.textContent.trim()
      console.log(`Target ${index}: "${text}"`)
      
      if (text === "-") {
        this.originalValues.set(target, "-")
        console.log(`Stored as dash for target ${index}`)
      } else {
        // Handle Rails number_with_precision output which uses decimal comma
        // For example: "160,00" should be parsed as 160.00
        let cleanText = text.replace(',', '.')
        const value = parseFloat(cleanText)
        console.log(`Original text: "${text}", cleaned text: "${cleanText}", parsed value: ${value}`)
        
        if (!isNaN(value)) {
          this.originalValues.set(target, value)
          console.log(`Stored value ${value} for target ${index}`)
        } else {
          console.log(`Failed to parse value for target ${index}`)
        }
      }
    })
    
    console.log(`Total targets found: ${this.valueTargets.length}`)
    console.log(`Total values stored: ${this.originalValues.size}`)
    
    // Initialize label styling
    this.updateLabelStyling()
  }

  toggle(event) {
    console.log("Toggle clicked, checkbox checked:", event.target.checked)
    this.isHours = !event.target.checked
    console.log("Is hours:", this.isHours)
    
    this.valueTargets.forEach((target, index) => {
      const originalValue = this.originalValues.get(target)
      console.log(`Processing target ${index}, original value:`, originalValue)
      
      if (originalValue === "-") {
        target.textContent = "-"
        console.log(`Target ${index}: kept as dash`)
      } else if (originalValue !== undefined && !isNaN(originalValue)) {
        if (this.isHours) {
          // Show hours
          const formatted = this.formatValue(originalValue)
          target.textContent = formatted
          console.log(`Target ${index}: set to hours ${formatted}`)
        } else {
          // Show days (hours divided by 8)
          const days = originalValue / 8
          const formatted = this.formatValue(days)
          target.textContent = formatted
          console.log(`Target ${index}: set to days ${formatted}`)
        }
      } else {
        console.log(`Target ${index}: skipped (no valid original value)`)
      }
    })

    // Update unit labels
    this.unitTargets.forEach((target, index) => {
      const newText = this.isHours ? "uren" : "dagen"
      target.textContent = newText
      console.log(`Unit target ${index}: set to "${newText}"`)
    })
    
    // Update label styling
    this.updateLabelStyling()
  }

  updateLabelStyling() {
    // Update hours label
    if (this.hasHoursLabelTarget) {
      this.hoursLabelTarget.className = this.hoursLabelTarget.className
        .replace(/text-blue-600|text-gray-500|font-semibold/g, '')
        .trim() + (this.isHours ? ' text-blue-600 font-semibold' : ' text-gray-500')
    }
    
    // Update days label  
    if (this.hasDaysLabelTarget) {
      this.daysLabelTarget.className = this.daysLabelTarget.className
        .replace(/text-blue-600|text-gray-500|font-semibold/g, '')
        .trim() + (!this.isHours ? ' text-blue-600 font-semibold' : ' text-gray-500')
    }
  }

  formatValue(value) {
    if (value === 0) return "-"
    // Match Rails number_with_precision with Dutch locale (comma as decimal separator)
    return value.toFixed(2).replace('.', ',')
  }
}